import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import pl from '../../public/locales/pl.json';

type DefaultTranslation = typeof pl;

declare module 'i18next' {
   interface CustomTypeOptions {
      defaultNS: 'translation';
      resources: {
         translation: DefaultTranslation;
      };
   }
}

export enum SupportedLanguages {
   PL = 'pl',
   EN = 'en',
}

export const LANGUAGE_FLAGS = {
   [SupportedLanguages.PL]: 'PL',
   [SupportedLanguages.EN]: 'GB',
};

i18n
   .use(HttpBackend)
   .use(LanguageDetector)
   .use(initReactI18next)
   .init({
      fallbackLng: SupportedLanguages.PL,
      debug: process.env.NODE_ENV === 'development',
      ns: ['translation'],
      defaultNS: 'translation',
      interpolation: {
         escapeValue: false,
      },
      backend: {
         loadPath: '/locales/{{lng}}.json',
      },
   });

export default i18n;
